import { range } from './array';
import date from './date';
import { strPadStart, toString } from './string';
export var rangeYearValue = function rangeYearValue(val) {
  if (val === 'now' || !val) {
    return date().get('year');
  }
  if (val.indexOf('-') === 0) {
    return date().subtract(parseInt(val.substr(1), 10), 'year').get('year');
  }
  var literal = date(val, 'YYYY').get('year');
  return literal || date().add(parseInt(val, 10), 'year').get('year');
};
export var getYearRange = function getYearRange(format) {
  var _format$split = format.split(':'),
    minYear = _format$split[0],
    maxYear = _format$split[1];
  return [rangeYearValue(minYear), rangeYearValue(maxYear)];
};
export var dayOptions = function dayOptions() {
  var options = range(1, 31).map(function (val) {
    return strPadStart(val, 2, '0');
  });
  return [''].concat(options);
};
export var monthOptions = function monthOptions() {
  var options = range(1, 12).map(function (val) {
    return strPadStart(val, 2, '0');
  });
  return [''].concat(options);
};
export var yearOptions = function yearOptions(rng) {
  var _getYearRange = getYearRange(rng),
    min = _getYearRange[0],
    max = _getYearRange[1];
  var options = range(min, max).map(function (val) {
    return toString(val);
  });
  return [''].concat(options);
};